import { render } from "./FunçaoPage.vue?vue&type=template&id=4280fb3d"
import script from "./FunçaoPage.vue?vue&type=script&lang=js"
export * from "./FunçaoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__